import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  SvgIcon
} from '@material-ui/core';
import {Menu as MenuIcon} from 'react-feather';
import Logo from 'src/components/Logo';
import {THEMES} from 'src/constants/Constants';
import Account from './Account';
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    ...theme.name === THEMES.LIGHT ? {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.main
    } : {},
    ...theme.name === THEMES.ONE_DARK ? {
      backgroundColor: theme.palette.background.default
    } : {}
  }, root2: {
    zIndex: theme.zIndex.drawer + 100,
    ...theme.name === THEMES.LIGHT ? {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.noBackground,
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
    } : {},
    ...theme.name === THEMES.ONE_DARK ? {
      backgroundColor: theme.palette.background.default
    } : {}
  },
  toolbar: {
    backgroundColor: "#3f51b5",
    height: 64,
  },
  toolbar2: {
    minHeight: 64,
    color: '#263238'
  }, logoStyles: {
    height: 30,
    marginRight: theme.spacing(2),
    "@media (min-width: 1200px)": {
      height: 40,
    }
  },
  menuStyles: {
    color: "black"
  },
  title: {
    flexGrow: 1,
  },
}));

const TopBar = ({className, onMobileNavOpen, ...rest}) => {
  const classes = useStyles();

  return (
    <AppBar
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onMobileNavOpen}
            className={classes.menuStyles}
          >
            <SvgIcon fontSize="small">
              <MenuIcon/>
            </SvgIcon>
          </IconButton>
        </Hidden>
        <RouterLink to="/">
          <Logo className={classes.logoStyles}/>
        </RouterLink>
        <Typography variant="h4" className={classes.title}>
          Food Training application
        </Typography>
        <Box
          ml={2}
          flexGrow={1}
        />
        {/* <Settings /> */}
        <Box ml={2}>
          <Account/>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

TopBar.defaultProps = {
  onMobileNavOpen: () => {
  }
};

export default TopBar;
